import { render, staticRenderFns } from "./SalicepaoloLogo.vue?vue&type=template&id=0957ab9a&scoped=true&"
var script = {}
import style0 from "./SalicepaoloLogo.vue?vue&type=style&index=0&id=0957ab9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0957ab9a",
  null
  
)

export default component.exports